import Header from './header';
import SearchArea from './searchArea';
import { KEY, URL } from '../constants/constants';
import SliderArea from './sliderArea';
import Footer from './footer';

export default class App {
  constructor(name) {
    this.name = name;
    this.key = KEY;
    this.url = URL;
  }

  init() {
    const header = new Header(this.name);
    header.init();

    const searchArea = new SearchArea(this.name);
    searchArea.init();

    const sliderArea = new SliderArea(this.name);
    sliderArea.init();

    const footer = new Footer(this.name);
    footer.init();
  }
}
